import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/money-bill-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320 144c53 0 96 50.1 96 112 0 61.9-43 112-96 112-53 0-96-50.2-96-112 0-61.9 43-112 96-112zM360 312v-16c0-4.4-3.6-8-8-8h-16v-88c0-4.4-3.6-8-8-8h-13.6 0c-4 0-10 1.8-13.3 4l-15.3 10.2c-2 1.3-3.6 4.3-3.6 6.7 0 1.3 0.6 3.3 1.3 4.4l8.9 13.3c1.3 2 4.3 3.6 6.7 3.6 1.3 0 3.3-0.6 4.4-1.3l0.5-0.3v55.4h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8zM608 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32v-320c0-17.7 14.3-32 32-32h576zM592 336v-160c-35.3 0-64-28.7-64-64h-416c0 35.3-28.7 64-64 64v160c35.3 0 64 28.7 64 64h416c0-35.3 28.7-64 64-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/money-bill-alt.js
// module id = 1800
// module chunks = 0